import axios from "axios";

export const state = {
    labpatientsamples: [],
};

export const getters = {
    labpatientsamples: state => state.labpatientsamples,
};

export const mutations = {
    setSamples(labpatientsamples, newValue) {
        state.labpatientsamples = newValue
    },
};

export const actions = {
    fetchLabPatientsamples({ commit }) {
        axios.get('/labpatientsamples').then(res => {
            commit('setSamples', res.data.visits)
        })
    },
};
